import { render, staticRenderFns } from "./ProtocoloVerdeGraosStatusRestricao.vue?vue&type=template&id=7a0eb13e&lang=pug"
import script from "./ProtocoloVerdeGraosStatusRestricao.vue?vue&type=script&lang=js"
export * from "./ProtocoloVerdeGraosStatusRestricao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports